import React, { Component } from 'react';
import Checkbox from '@material/react-checkbox';
import "@material/react-checkbox/dist/checkbox.css";

class MyCheckBox extends Component {

  static defaultProps = {
    disabled: false
  };

  render() {
    const { title, img, value, disabled, onChange, name, className } = this.props;
    return (
      <div className={"row " + className}>
        <div className="col-12">
          <div className="row">
            <div className="d-flex align-items-center">
              <Checkbox
                checked={value}
                disabled={disabled}
                indeterminate={disabled}
                onChange={() => onChange({target: {name: name, value: !value}})}
              />
              {img && <img height="30px" className="ml-2 mr-3" src={img} alt=""/>}
              <div className="my-font-sz-08 my-font-wg-500">{title}</div>
            </div>
          </div>
          <div className="row mb-3">
          </div>
        </div>
      </div>
    );
  }
}

export default MyCheckBox;
